import styled from 'styled-components'
import { colors } from 'Styled/variables'

export const GenresAndLanguagesRow = styled.div`
  margin-bottom: 8px;
  font-size: 14px;
  line-height: 21px;
  color: ${colors.mainText};

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
`

export const RowLabel = styled.span`
  margin-right: 8px;
  font-size: 14px;
  line-height: 21px;
  color: ${colors.greyTextWhiteBg};
`
